import * as PropTypes from 'prop-types';
import * as React from 'react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { LanguageCode } from 'types/tenants/language-code';

import './styles.css';

export interface Props {
  language: LanguageCode;
  count: number;
}

export const OperationCount: React.StatelessComponent<Props> = (props) => {
  const i18n = getI18n();
  return (
    <div className="operation-count-header">
      {i18n.t(translations.ScanCount)}: <span className="scan-count">{props.count}</span>
    </div>
  );
};

OperationCount.propTypes = {
  count: PropTypes.number
} as React.WeakValidationMap<Props>;


// WEBPACK FOOTER //
// ./src/components/operation-grid/operation-count/component.tsx